import BaseModel from "../BaseModel";
import SampleNoteType from './SampleNoteType'
import Sample from './Sample';

export default class SampleNote extends BaseModel {
    static entity = 'sampleNotes';
    static primaryKey = "uuid";
    static fields(){
        return {
            uuid: this.attr(null),
            sample_uuid: this.attr(null),
            sample_note_type_uuid: this.attr(null),
            note: this.attr(null),
            created_by: this.attr(null),
            updated_by: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            //Relations
            note_type: this.belongsTo(SampleNoteType, 'sample_note_type_uuid'),
            sample: this.belongsTo(Sample, 'sample_uuid')
        }
    }

    static ignoredLogFields(){
        return ['note_type','sample', 'created_at', 'updated_at']
    }

    static name(){
        return "SampleNote"
    }

    static route(){
        return process.env.VUE_APP_RECORDED_API + '/sampleNotes';
    }
    
    static apiConfig = {
        ...super.apiConfig,
        headers: {
            "Accept": "application/json",
            "Authorization": process.env.VUE_APP_RECORDED_API_KEY,
            "VueRoute": window.location.href,
        }
    }
}
